const elements = {
  navHome: document.querySelectorAll('.js-nav-home'),
  navFavorites: document.querySelectorAll('.js-nav-favorites'),
  body: document.querySelector('body'),
  burger: document.querySelector('.js-burger'),
  filter: document.querySelector('.js-filter'),
  gallery: document.querySelector('.js-gallery'),
  gallerySubtitle: document.querySelector('.js-subtitle'),
  pagination: document.querySelector('.js-pagination'),
  searchForm: document.querySelector('.js-search-form'),
  resetSearchForm: document.querySelector('.js-reset-form'),
  backBtn: document.querySelector('.js-back-button'),
  subscribeForm: document.querySelector('.js-subscribe-form'),
  quote: document.querySelector('.js-quote'),
  policyBtn: document.querySelector('.js-policy-modal-open'),
  termsBtn: document.querySelector('.js-terms-modal-open'),
  scrollTopBtn: document.querySelector('.js-scroll-top-button'),
  btnCloseBurger: document.querySelector('.mobile-menu-close-btn'),
  btnOpenBurger: document.querySelector('.mobile-menu-open-btn'),
  burgerMenu: document.querySelector('.mobile-menu-backdrop'),
  favoritesAnchor: document.querySelector('.js-anchor'),
};

export { elements };
